import EndEnhancer from './EndEnhancer';

export default EndEnhancer;
